var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 内部错误：500 "),_c('div',[_vm._v(" "+_vm._s(_vm.$route.query.err)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }